import {Singleton} from 'annotation';
import environment from 'environment';

import ProxyService from './Proxy';
import EntityAware from '../entity/EntityAware';
import Asrama from "../entity/Asrama";
import Parameter from "./Parameter";
import {Deserialize} from "cerialize";
import Response from "./Response";

@Singleton
export default class AsramaService extends ProxyService {

    public api: string = environment.ASRAMA_API;   // define api url to fetch data

    public serializer: EntityAware = Asrama;

    public async findByWilayah(wilayah: string): Promise<any> {
        return this.request(new Parameter().setUrl(this.api + `/wilayah/${wilayah}`))
            .then((response: Response) => {
                return Deserialize(response.getData([]), Asrama);
            });
    }

}
